import { ProductComponent } from '~/components/ProductPage/WardrobeProductPage'
import {
  createWardrobeConfigurator,
  getNewCollectionPalette,
} from './wardrobeConfigFactory'
import { OpeningType } from '~/components/ThreeDModel/furnitureConfig'

/**
 * Configurator for the new wardrobe collection.
 * Same as standard wardrobe except only one handle type: NewCollectionHandle.
 * Colors and interior templates match current wardrobe (configurable later).
 */
export const WardrobeNewCollectionConfigurator: () => ProductComponent[] =
  createWardrobeConfigurator({
    handleOptions: [OpeningType.NewCollectionHandle],
    defaultHandle: OpeningType.NewCollectionHandle,
    colorOptions: getNewCollectionPalette(),
    defaultColor: 'Brown Belmont Oak', // actual default is set in configUrl.ts (productDefaultColors)
    widthRange: [40, 280],
  })
